'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable'),
	cleanUpContentForExport = require('./clean-up-content-for-export');
module.exports = function CopyFileController(config, fileModel, contentRetriver, pageController) {
	let copyId;
	const dispatcher = observable(this),
		tryWatermarking = async (metadata) => {
			if (!metadata || !metadata.id || !metadata.id.split) {
				return;
			}
			try {
				const components  = metadata.id.split('/'),
					fileId = components[components.length - 1];
				await fileModel.requestWatermarkForFileKey(`${fileId}.pointer`, true);

			} catch (e) {
				console.error(e); //eslint-disable-line
			}
		},
		start = function () {
			dispatcher.dispatchEvent('stage', 'start');
		},
		copyTo = async function (fileName) {
			if (fileName && fileName.trim().length > 0) {
				try {
					dispatcher.dispatchEvent('stage', 'progress');
					const content = await contentRetriver(),
						cleanContentForExport = cleanUpContentForExport(content),
						stringifiedContentForExport = JSON.stringify(cleanContentForExport),
						metadata = await fileModel.createFile(fileName, false, stringifiedContentForExport);
					copyId = metadata.id;
					await tryWatermarking(metadata);
					dispatcher.dispatchEvent('stage', 'done');
				} catch(error) {
					if (error === 'overwriting-file') {
						dispatcher.dispatchEvent('stage', 'error-overwriting-file');
					} else if (error === 'not-authenticated') {
						dispatcher.dispatchEvent('stage', 'error-not-authenticated');
					} else {
						dispatcher.dispatchEvent('stage', 'error');
					}
				}
			} else {
				dispatcher.dispatchEvent('stage', 'error');
			}
		},
		editCopy = function () {
			pageController.editFileId(copyId);
		};
	Object.freeze(Object.assign(this, {start, copyTo, editCopy}));
};
